import SbEditable from 'storyblok-react';

import { CallToAction } from './CallToAction';

export const CallToActionDynamic = ({ content, ...props }) => {
  return (
    <SbEditable content={content}>
      <CallToAction
        divider={false}
        {...content?.call_to_action?.content}
        {...props}
      />
    </SbEditable>
  );
};
